import React from 'react'
import { Container } from './component.styles'
import { CustomCheckBox } from '../CustomCheckBox/component'
import { SITE_CHANGE_MESSAGE } from './constant'
import PropTypes from 'prop-types'

const SiteChangeConfirmation = ({ siteChangeChecked, setFieldValue }) => {
  return (
    <Container siteChangeChecked={siteChangeChecked}>
      <CustomCheckBox
        checked={siteChangeChecked}
        isDisabled={false}
        name={siteChangeChecked}
        onChange={() => setFieldValue('siteChangeChecked', !siteChangeChecked)}
        text={SITE_CHANGE_MESSAGE}
      />
    </Container>
  )
}

SiteChangeConfirmation.propTypes = {
  setFieldValue: PropTypes.func,
  siteChangeChecked: PropTypes.string,
}
export default SiteChangeConfirmation



// WEBPACK FOOTER //
// ./src/components/EditLicenseModalSiteChangeConfirmation/component.js